import React from 'react';
import './TopperGrid.css';
import { Medal } from 'lucide-react';

const toppers = [
  {
    name: 'Aditya Raj',
    rank: 'AIR 1',
    year: 2024,
    photo: 'https://randomuser.me/api/portraits/men/11.jpg',
  },
  {
    name: 'Sneha Kapoor',
    rank: 'AIR 2',
    year: 2023,
    photo: 'https://randomuser.me/api/portraits/women/22.jpg',
  },
  {
    name: 'Kunal Mehra',
    rank: 'AIR 3',
    year: 2022,
    photo: 'https://randomuser.me/api/portraits/men/33.jpg',
  },
  {
    name: 'Riya Nair',
    rank: 'AIR 4',
    year: 2024,
    photo: 'https://randomuser.me/api/portraits/women/44.jpg',
  },
  {
    name: 'Ishaan Verma',
    rank: 'AIR 5',
    year: 2023,
    photo: 'https://randomuser.me/api/portraits/men/55.jpg',
  },
];

const TopperGrid = () => {
  return (
    <section className="topper-page-section">
      <div className="topper-page-container">
        <div className="topper-page-header">
          <Medal className="topper-page-icon" />
          <h2 className="topper-page-title">Our Proud Toppers</h2>
          <p className="topper-page-subtitle">
            Consistent success stories year after year.
          </p>
        </div>

        <div className="topper-page-grid">
          {toppers.map((topper, index) => (
            <div className="topper-page-card" key={index}>
              <div className="topper-page-photo-wrapper">
                <img
                  src={topper.photo}
                  alt={topper.name}
                  className="topper-page-photo"
                />
              </div>
              <h3 className="topper-page-name">{topper.name}</h3>
              <p className="topper-page-rank">{topper.rank}</p>
              <span className="topper-page-year">{topper.year}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopperGrid;
